import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Label,
  Form,
  TimeField,
  SelectField,
  Button,
  OnOffField,
  FilteredListField,
} from '../common';
import { isStaffType } from './index';

export default function EntityForm({ show, values: formValues, onClose, onSave, staffMembers }) {
  if (!show) {
    return null;
  }
  return (
    <Container
      onClose={onClose}
      style={{
        position: 'absolute',
        top: 60,
        right: 0,
        height: 600,
        width: 500,
      }}
    >
      {Object.keys(formValues).length
        ? (
          <Label
            type="title"
          >Schedule hours for your clinic/staff</Label>
        )
        : (
          <Label
            type="title"
          >Add New Schedule</Label>
        )}
      <Form
        values={formValues}
        validate={(touched, values) => {
          const errors = {};
          if (!values.start) {
            errors.start = 'Shouldn\'t be empty';
          }
          if (!values.end) {
            errors.end = 'Shouldn\'t be empty';
          }
          if (!values.type) {
            errors.type = 'Shouldn\'t be empty';
          }
          if ((values.day || []).length === 0) {
            errors.day = 'Select at least one day';
          }
          if (isStaffType(values.type) && (values.staff_ids || []).length === 0) {
            errors.staff_ids = 'Select at least one staff member';
          }
          Object.keys(touched).forEach((field) => {
            if (field === 'start' && (values.start > values.end)) {
              errors.start = 'Start Time should be smaller';
            }
            if (field === 'end' && (values.start > values.end)) {
              errors.end = 'End Time should be bigger';
            }
          });
          return errors;
        }}
      >{({ values, getHandler, errors, hasErrors }) => {
        return (
          <div>
            <div>
              <OnOffField
                style={{ width: '100%' }}
                label="Schedule"
                value={values.day || []}
                error={errors.day}
                onChange={getHandler('day')}
                options={[
                  { value: 'SUNDAY', label: 'S' },
                  { value: 'MONDAY', label: 'M' },
                  { value: 'TUESDAY', label: 'T' },
                  { value: 'WEDNESDAY', label: 'W' },
                  { value: 'THURSDAY', label: 'T' },
                  { value: 'FRIDAY', label: 'F' },
                  { value: 'SATURDAY', label: 'S' },
                ]}
              />
            </div>
            <div>
              <SelectField
                style={{ width: '100%' }}
                value={values.type}
                onChange={getHandler('type')}
                label="Schedule For"
                error={errors.type}
                options={[
                  { value: 'BUSINESS', label: 'Business' },
                  { value: 'BUSINESS_BREAK', label: 'Business Break' },
                  { value: 'STAFF', label: 'Staff' },
                  { value: 'STAFF_BREAK', label: 'Staff Break' },
                ]}
              />
            </div>
            {(values.type || '').indexOf('STAFF') !== -1
              ? (
                <div>
                  <FilteredListField
                    style={{ width: '100%' }}
                    label="Staff"
                    value={values.staff_ids}
                    error={errors.staff_ids}
                    onChange={getHandler('staff_ids')}
                    serialize={(staffMember) => {
                      return `${staffMember.id}`;
                    }}
                    options={staffMembers}
                  >
                    {(staffMember) => {
                      return `${staffMember.first_name} ${staffMember.last_name}`;
                    }}
                  </FilteredListField>
                </div>
              )
              : ''
            }
            <div>
              <TimeField
                style={{ width: '45%', paddingRight: 5 }}
                label="Start Time"
                value={values.start}
                onChange={getHandler('start')}
                error={errors.start}
              />
              <TimeField
                style={{ width: '45%', paddingLeft: 5 }}
                label="End Time"
                value={values.end}
                onChange={getHandler('end')}
                error={errors.end}
              />
            </div>
            <div
              style={{ marginTop: 30 }}
            >
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  if (!hasErrors) {
                    onSave(values);
                    onClose();
                  }
                }}
                disabled={hasErrors}
                type="primary"
              >Save</Button>
            </div>
          </div>
        );
      }}</Form>
    </Container>
  );
}

EntityForm.propTypes = {
  show: PropTypes.bool.isRequired,
  values: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  staffMembers: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

EntityForm.defaultProps = {
  values: {},
};
